import {decorate, observable, action} from "mobx"

export class PaginationStore {
  currentPage = 1
  postPerPage = 10

  setCurrentPage(currentPage) {
    this.currentPage = currentPage
  }

  setPostPerPage(postPerPage) {
    this.postPerPage = postPerPage
  }
  resetDefault() {
    this.currentPage = 1
    this.postPerPage = 10
  }

  moveToPage(selectedRowIndex) {
    //This function sets the pagination based on the row selected.
    //The page containing the selected row is set as active.
    let pageNumber = Math.floor(selectedRowIndex / this.postPerPage) + 1
    this.setCurrentPage(pageNumber)
  }
}

decorate(PaginationStore, {
  currentPage: observable,
  postPerPage: observable,
  setCurrentPage: action,
  setPostPerPage: action,
  resetDefault: action,
  moveToPage: action,
})
